import Reveal from "@/components/Reveal";
import { imgUrl } from "@/lib/api";

export default function Trust({ trust }) {
  if (!trust || !trust.logos || !trust.logos.length) return null;
  return (
    <section className="relative py-20 md:py-24 bg-[#EBECE8] border-b border-black/10 overflow-hidden" data-testid="trust-section">
      {trust.image && (
        <>
          <img
            src={imgUrl(trust.image)}
            alt="Rénovation de parking par CITEK"
            className="absolute inset-0 w-full h-full object-cover"
            data-testid="trust-bg-image"
          />
          <div className="absolute inset-0 bg-[#EBECE8]/88" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#EBECE8]/70 via-[#EBECE8]/60 to-[#EBECE8]/85" />
        </>
      )}
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-tech text-sm uppercase tracking-[0.24em] text-citek-greenDark" data-testid="trust-kicker">
            {trust.kicker}
          </p>
          <div className="mt-4 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="font-display font-extrabold uppercase tracking-tight text-zinc-900 text-3xl md:text-4xl leading-[1.05]" data-testid="trust-title">
              {trust.title}
            </h2>
            {trust.subtitle && (
              <p className="max-w-sm text-base leading-relaxed text-zinc-600" data-testid="trust-subtitle">
                {trust.subtitle}
              </p>
            )}
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {trust.logos.map((l, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div
                data-testid={`trust-logo-${i}`}
                className="group flex items-center justify-center h-28 md:h-32 rounded-lg border border-black/10 bg-white px-6 transition-all duration-300 hover:border-citek-green/50 hover:shadow-md"
              >
                {l.image && (
                  <img
                    src={imgUrl(l.image)}
                    alt={l.name}
                    className="max-h-14 md:max-h-16 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                    data-testid={`trust-logo-image-${i}`}
                  />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
